import React, { useEffect, useState,useRef } from "react";
import Head from "../../components/Header/head";
import { useLocation } from "react-router-dom";
import axiosInstance from "../../services/axios";
import { useSelector, useDispatch } from "react-redux";
import { getAvatar } from "../../redux/actions/avatar_action";
import { getDebateDetails } from "../../redux/actions/debate_details_action";
import TimerFunction from "../../common/js/debate_timer";
import TeamTimer from "../../common/js/team_timer";
import { TopicProvider } from "../../redux/actions/websocket_actions/topic_action";
import { ToastContainer, toast } from 'react-toastify';
import { useContext } from "react";
import { WebsocketContext } from "../../websocket/context";
import { WebSocketRoomProvider } from "../../websocket/roomprovidercontext";
import  secureLocalStorage  from  "react-secure-storage";
import { RoomIdProvider } from "../../redux/actions/websocket_actions/roomId_action";
import { createVote } from "../../redux/actions/websocket_actions/voting_action";
import { createCollectionIndexedDB } from "../../utils/indexed_db";
import { winner_notification } from "../../utils/notification";
import { useNavigate } from "react-router-dom";
import { clearAllSecureLocalStorage } from "../../utils/utils";
import "../mediator/mediator.css";

function Mediator(){

    const location = useLocation();
    const {roomId} = useSelector((state)=>state.roomIdReducer);
    const dispatch = useDispatch();
    const room_id = location.state.room_id
    const virtaul_id = location.state.virtual_id
    const idb = createCollectionIndexedDB();
    const navigate = useNavigate();
    


    if(roomId === null){
        dispatch(RoomIdProvider(room_id));
    }
    const notificaton = ()=>{
        toast('please select which side will speak first..', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });
    }



    const [ready, val, send] = useContext(WebsocketContext); 
    const debate_id = location.state.debate_id
    const [speak,setSpeak] = useState(false);
    const [leftSpeak,setLeftSpeak] = useState(false);
    const [rightSpeak,setRightSpeak] = useState(false);
    
    const[start,setStart]=useState(true);
    const mediator_start = useRef(false);
    const [fetch_details,setfetchDetails] = useState(false)
    const [complete,setComplete] = useState([])
    const [finishDebate,setFinishDebate] = useState(false)
    const [winner ,setWinner] = useState();
    const [firstTeam,setFirstTeam] = useState()
    const [secondTeam,setSecondTeam] = useState()   
    const avatar = useSelector((state)=>state.avatarReducer);
    const debate = useSelector((state)=>state.debateDetailsReducer);
    const topic = useSelector((state)=>state.topicReducer);
    const auth = useSelector((state)=>state.jwtAuthreducer);


    const skin_color_obj = {"skin-1":"skin-color-1.png","skin-2":"skin-color-2.png","skin-3":"skin-color-3.png"}
    const male_hair_color_obj = {"hair-1":"male-hair-color-1.png","hair-2":"male-hair-color-2.png","hair-3":"male-hair-color-3.png","hair-4":"male-hair-color-4.png"}
    const female_hair_color_obj = {"hair-5":"female-hair-color-1.png","hair-6":"female-hair-color-2.png","hair-7":"female-hair-color-3.png","hair-8":"female-hair-color-4.png"}
    const dress= {"dress-1":"mediator-clothe-color-1.png","dress-2":"mediator-clothe-color-2.png","dress-3":"mediator-clothe-color-3.png","dress-4":"mediator-clothe-color-4.png"}
    

    
   

    useEffect(()=>{
        const fetchData = async()=>{
            try{
                await axiosInstance.post(`/join/mediator`,{"debate_id":debate_id}).then(
                    (res)=>{
                        res.status === 200 ?setfetchDetails(true):setfetchDetails(false)
                    }
                    );
            }
            catch(err){
                throw(err)
            }
        }
        return()=>{
        getData();
        fetchData(); 
        dispatch(getAvatar());
               
        }
 
     },[]);

    
    useEffect(()=>{
        if(fetch_details){
            dispatch(getDebateDetails());
        }

    },[fetch_details])



    useEffect(()=>{
        if(complete.includes(secureLocalStorage.getItem("topic"))){
            startTimer({action:"timer",data:{pause:false,team:"both_team"}})
        }
    },[secureLocalStorage.getItem("topic")])
    
    const markComplete = (topic)=>{
        if(complete.length!=0){
            getData()
        }
        if (!complete.includes(topic)){
            handleTopics(topic)
            send(JSON.stringify({action:"mark_topic_finish",data:topic}))
        }
        console.log(debate.extra_details.topics[0].length,complete,"from mark complete")

       
    }
   
    useEffect(()=>{
        if((complete.length!=0) && (Object.keys(debate.extra_details).length!=0)){
            if(debate.extra_details.topics[0].length == complete.length){
                if(finishDebate === false){
                    handleFinish()
                }
            }
        }
    },[complete,debate])

    const startTimer = (values)=>{
        if(values.data.team === "both_team"){
            setStart(!values.data.pause)
            send(JSON.stringify(values));

        }
       
    }

    const sendMessage = (data)=>{
        dispatch(TopicProvider(data.action,data.data));
        send(JSON.stringify(data));
        if(data.action === "topic"){
            dispatch(createVote({"virtual_id":virtaul_id,"topic":data.data}))
        }
    }

    const teamStartStop = (values)=>{
        setStart(!values.data.pause)
        if(values.data.team === "left_team"){
            setLeftSpeak(values.data.pause)

        }
        if(values.data.team === "right_team"){
            setRightSpeak(values.data.pause)

        }
    
        send(JSON.stringify(values));
    }

    const handleFinish = ()=>{
        const dbPromise = idb.open("bedate-db")
        dbPromise.onsuccess = ()=>{
            const db = dbPromise.result;
            const tx = db.transaction("topicsData",'readwrite');
            const topicData = tx.objectStore('topicsData');
            const topics = topicData.put({
                virtual_id:virtaul_id,
                topic:complete,
                finished:true
            });
            topics.onsuccess = ()=>{
                tx.oncomplete =()=>{
                    db.close();
                };
                getData()
            }
            topics.onerror = ()=>{
                console.log("an error occured")
            }


        }
    }

    const handleTopics = (topic)=>{
        const dbPromise = idb.open("bedate-db")
        dbPromise.onsuccess = ()=>{
            const db = dbPromise.result;
            const tx = db.transaction("topicsData",'readwrite');
            const topicData = tx.objectStore('topicsData');
            let updatedValue = [...complete,topic]
            const topics = topicData.put({
                virtual_id:virtaul_id,
                topic:updatedValue,
                finished:false
            });
            topics.onsuccess = ()=>{
                tx.oncomplete =()=>{
                    db.close();
                };
                getData()
            }
            topics.onerror = ()=>{
                console.log("an error occured")
            }


        }
    }

    const deleteAllRecords = () => {
        const dbName = 'bedate-db';
        const objectStoreName = 'topicsData';
    
        const request = indexedDB.open(dbName);
    
        request.onsuccess = (event) => {
          const db = event.target.result;
          const transaction = db.transaction(objectStoreName, 'readwrite');
          const objectStore = transaction.objectStore(objectStoreName);
          const cursorRequest = objectStore.openCursor();
    
          cursorRequest.onsuccess = (event) => {
            const cursor = event.target.result;
            if (cursor) {
              cursor.delete();
              cursor.continue();
            }
          };
    
          transaction.oncomplete = () => {
            console.log('All records deleted successfully');
            // Perform any additional actions after deleting all records if needed
          };
    
          transaction.onerror = (event) => {
            console.log('Error deleting records:', event.target.error);
          };
        };
      };

    const getData = ()=>{
        const dbPromise = idb.open("bedate-db")       
        dbPromise.onsuccess=()=>{
            const db = dbPromise.result;
            const tx = db.transaction("topicsData",'readonly');
            const topicData = tx.objectStore('topicsData');
            const topics = topicData.getAll()
            topics.onsuccess=(query)=>{
                if(query.srcElement.result[0]){
                    let updatedValue = query.srcElement.result[0].topic
                    setComplete(updatedValue)
                    setFinishDebate(query.srcElement.result[0].finished)
                }

            }
            topics.onerror = (query)=>{
                alert("error")
            }
            tx.oncomplete=()=>{
                db.close()
            }
        }
           
      
    }
    useEffect(()=>{
        if(ready){
            send(JSON.stringify({action:"start",data:true}));
        }

    },[ready,send])

    const markDebateFinish = async ()=>{
        try{
            await axiosInstance.get(`/finish/votes/${virtaul_id}`).then(
                (res)=>{
                    send(JSON.stringify({action:"announce_winner",data:{winner:res.data.winner}}));
                    clearDebate(debate_id)
                    clearAllSecureLocalStorage();
                    deleteAllRecords()
                    navigate("/winner",{state:{team:res.data.winner}})

                }
                )
        }
        catch(err){
            throw(err)
        }
        
    }
    const clearDebate = (debate_id)=>{
        axiosInstance.delete(`/finish/debate/${debate_id}`)
    }


    
    return(
        <>
                
               

                <Head/>

                
                <div className="inner-page-wrapper">
    
                <div className="debate-title-header">
            <div className="container d-flex align-items-center flex-column">
                <div className="title">
                    {debate.debate.title}
                </div>
                {topic.action
                ?
                <h1><a id="current_topic">{topic.action === 'topic' ? topic.data : 'No Topic'}</a></h1>
                :
                <h1><a id="current_topic">{secureLocalStorage.getItem("topic")===null ? `Topic Will be display here`:secureLocalStorage.getItem("topic")}</a></h1>
                }
            </div>
                </div>

                <div id="myProgress">
                <div id="myBar"></div>
                </div>


                <div className="mediator-dashboard-box">                    
                    
                    <div className="container d-flex align-items-md-center justify-content-md-between flex-wrap">
                        <div className="dashboard-team-block">
                            <div className="dashboard-team-block-title">
                                Team 1
                            </div>

                            <div className="dashboard-team-block-votes">
                                <div className="vote-numbers">
                                    <svg width="15" height="16" viewBox="0 0 15 16" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0.595854 7.06724C0.655338 7.00605 0.733286 6.97393 0.811902 6.97361H3.16775C3.24682 6.97388 3.32521 7.00611 3.38508 7.06752C3.44536 7.12935 3.48152 7.21575 3.48183 7.30849V15.1651C3.48152 15.2579 3.44536 15.3443 3.38508 15.4061C3.32528 15.4674 3.24698 15.4997 3.168 15.5H0.811789C0.733213 15.4997 0.655311 15.4675 0.595854 15.4064C0.535842 15.3446 0.499975 15.2584 0.5 15.1659V15.1658V7.30786L0.5 7.30772C0.499975 7.21523 0.535842 7.12896 0.595854 7.06724ZM12.9848 14.1342C12.9479 14.2258 12.8941 14.3082 12.8271 14.3772L4.92745 14.4749V7.31182C5.11068 7.09108 5.25736 6.84116 5.36163 6.57196L5.36205 6.57088L6.65442 3.21104L6.68775 3.12438V3.03154V1.04549C6.70707 0.888174 6.78247 0.746416 6.89579 0.646649C7.00998 0.546121 7.15446 0.495115 7.30033 0.50037C7.43308 0.506959 7.56363 0.540755 7.68435 0.600205C7.80575 0.659988 7.91507 0.744671 8.00536 0.849869L8.0053 0.849918L8.01106 0.856395C8.32216 1.20643 8.56246 1.61749 8.71718 2.06563C8.87183 2.51361 8.93767 2.98913 8.91061 3.46408C8.89071 3.79856 8.83256 4.12939 8.73743 4.44973C8.66957 4.66854 8.57571 4.87766 8.45812 5.07238L8.44917 5.08719L8.44127 5.10259C8.42606 5.13223 8.40951 5.16192 8.38609 5.20391C8.3828 5.20981 8.37938 5.21595 8.3758 5.22237L7.9617 5.9657H8.8126H13.6472C13.8406 5.96621 14.0297 6.03511 14.1823 6.16344C14.3353 6.29208 14.4424 6.47301 14.4826 6.67694C14.5228 6.88098 14.4928 7.09259 14.3989 7.2753C14.3051 7.45778 14.1542 7.59857 13.9744 7.67673L13.2285 8.00093L13.8545 8.52013C13.861 8.52552 13.8672 8.53147 13.873 8.53796L13.8797 8.54535L13.8866 8.55248C14.0541 8.72469 14.1504 8.96063 14.1505 9.20921C14.1504 9.38917 14.0998 9.56441 14.0062 9.71405C13.9126 9.86362 13.7803 9.98067 13.6265 10.0531L12.9216 10.3849L13.5169 10.8875C13.6483 10.9984 13.748 11.1465 13.8028 11.3156C13.8576 11.4848 13.8647 11.6668 13.8232 11.8402C13.7817 12.0136 13.6937 12.1699 13.5709 12.2916C13.4483 12.4133 13.2961 12.4956 13.1325 12.5308L12.3084 12.7085L12.8595 13.3465C12.9757 13.4811 13.0414 13.657 13.0409 13.8411L13.0409 13.843C13.041 13.9433 13.0218 14.0422 12.9848 14.1342Z"
                                            stroke="#7024c4" fill="#7024c4" />
                                    </svg>
                                    <a id="team1totalvotemediator">{debate.debate.team_1_vote}</a>
                                </div>
                                <span>votes</span>
                            </div>

                            <div className="dashboard-team-block-time">
                                Time Left
                                {debate.debate.debate_id 
                                ?
                                <TeamTimer team="left_team" total_hour={debate.debate.total_hour?debate.debate.total_hour:"0"} total_minutes={debate.debate.total_minutes?debate.debate.total_minutes:"0"} room_id={room_id} virtual_id={virtaul_id} />
                                :
                                ""
                                }
                            </div>
                            <span id="left_side_stop"  href="#" className={leftSpeak ? "btn btn-primary btn-primary-o mb-2":"btn btn-primary btn-primary-o mb-2 d-none"} onClick={()=>teamStartStop({action:"timer",data:{pause:false,team:"left_team"}})}>
                                <svg className="mr-2" width="15" height="22" viewBox="0 0 15 22" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M14.4444 5.71464C14.1389 5.71464 13.8889 5.97179 13.8889 6.28609V10.5719C13.8889 14.2006 11.0278 17.1436 7.5 17.1436C3.97222 17.1436 1.11111 14.2006 1.11111 10.5719V6.28609C1.11111 5.97179 0.861111 5.71464 0.555556 5.71464C0.25 5.71464 0 5.97179 0 6.28609V10.5719C0 14.6292 3.05556 17.9721 6.94444 18.2579V20.8579H3.88889C3.58333 20.8579 3.33333 21.1151 3.33333 21.4294C3.33333 21.7437 3.58333 22.0008 3.88889 22.0008H11.6667C11.9722 22.0008 12.2222 21.7437 12.2222 21.4294C12.2222 21.1151 11.9722 20.8579 11.6667 20.8579H8.05556V18.2579C11.9444 17.9721 15 14.6292 15 10.5719V6.28609C15 5.97179 14.75 5.71464 14.4444 5.71464Z" />
                                    <path
                                        d="M7.5007 15.429C10.1118 15.429 12.2229 13.2575 12.2229 10.5717V4.85729C12.2229 2.17149 10.1118 0 7.5007 0C4.88959 0 2.77848 2.17149 2.77848 4.85729V10.5717C2.77848 13.2575 4.88959 15.429 7.5007 15.429ZM3.88959 9.42885H7.22292C7.52848 9.42885 7.77848 9.1717 7.77848 8.8574C7.77848 8.54311 7.52848 8.28596 7.22292 8.28596H3.88959V7.14307H7.22292C7.52848 7.14307 7.77848 6.88592 7.77848 6.57162C7.77848 6.25733 7.52848 6.00018 7.22292 6.00018H3.88959V4.85729H7.22292C7.52848 4.85729 7.77848 4.60014 7.77848 4.28584C7.77848 3.97155 7.52848 3.7144 7.22292 3.7144H4.05626C4.52848 2.22864 5.88959 1.14289 7.5007 1.14289C9.5007 1.14289 11.1118 2.80008 11.1118 4.85729V10.5717C11.1118 12.6289 9.5007 14.2861 7.5007 14.2861C5.5007 14.2861 3.88959 12.6289 3.88959 10.5717V9.42885Z" />
                                    <line x1="13.3904" y1="1.31235" x2="1.39043" y2="16.3123" stroke="#F1592A" />
                                </svg>
                                Stop
                            </span>

                                
                            <span id="left_side_speak"  href="#" className={leftSpeak == false ?"btn btn-primary mb-2":"btn btn-primary mb-2 d-none"} onClick={()=>teamStartStop({action:"timer",data:{pause:true,team:"left_team"}})}>
                                <svg className="mr-2" width="15" height="22" viewBox="0 0 15 22" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M14.4444 5.71464C14.1389 5.71464 13.8889 5.97179 13.8889 6.28609V10.5719C13.8889 14.2006 11.0278 17.1436 7.5 17.1436C3.97222 17.1436 1.11111 14.2006 1.11111 10.5719V6.28609C1.11111 5.97179 0.861111 5.71464 0.555556 5.71464C0.25 5.71464 0 5.97179 0 6.28609V10.5719C0 14.6292 3.05556 17.9721 6.94444 18.2579V20.8579H3.88889C3.58333 20.8579 3.33333 21.1151 3.33333 21.4294C3.33333 21.7437 3.58333 22.0008 3.88889 22.0008H11.6667C11.9722 22.0008 12.2222 21.7437 12.2222 21.4294C12.2222 21.1151 11.9722 20.8579 11.6667 20.8579H8.05556V18.2579C11.9444 17.9721 15 14.6292 15 10.5719V6.28609C15 5.97179 14.75 5.71464 14.4444 5.71464Z"
                                        fill="white" />
                                    <path
                                        d="M7.5007 15.429C10.1118 15.429 12.2229 13.2575 12.2229 10.5717V4.85729C12.2229 2.17149 10.1118 0 7.5007 0C4.88959 0 2.77848 2.17149 2.77848 4.85729V10.5717C2.77848 13.2575 4.88959 15.429 7.5007 15.429ZM3.88959 9.42885H7.22292C7.52848 9.42885 7.77848 9.1717 7.77848 8.8574C7.77848 8.54311 7.52848 8.28596 7.22292 8.28596H3.88959V7.14307H7.22292C7.52848 7.14307 7.77848 6.88592 7.77848 6.57162C7.77848 6.25733 7.52848 6.00018 7.22292 6.00018H3.88959V4.85729H7.22292C7.52848 4.85729 7.77848 4.60014 7.77848 4.28584C7.77848 3.97155 7.52848 3.7144 7.22292 3.7144H4.05626C4.52848 2.22864 5.88959 1.14289 7.5007 1.14289C9.5007 1.14289 11.1118 2.80008 11.1118 4.85729V10.5717C11.1118 12.6289 9.5007 14.2861 7.5007 14.2861C5.5007 14.2861 3.88959 12.6289 3.88959 10.5717V9.42885Z"
                                        fill="white" />
                                </svg>
                                Speak
                            </span>
                            


                        </div>

                        <div className="mediator-action-col text-center">
                            <div className="mediator-avatar">
                                {/* <!-- Add/remove className "d-none" when mediator is female --> */}
                                
                                
                                <div className={avatar.gender === "male"?"avatar male":"avatar male d-none"}>
                                    <div className="hair">
                                        <img src={ process.env.PUBLIC_URL+`img/${male_hair_color_obj[avatar.hair_color]}` } width="73" alt="" title="" />
                                    </div>
                                    <div className="face">
                                        <img src={ process.env.PUBLIC_URL+`img/${skin_color_obj[avatar.skin_tone]}` }  width="54" alt="" title="" />
                                    </div>
                                    <div className="body">
                                        <img src={ process.env.PUBLIC_URL+`img/${dress[avatar.dress_color]}` } width="92" alt="" title="" />
                                    </div>
                                </div>

                                {/* <!-- Add/remove className "d-none" when mediator is male --> */}
                                
                                <div className={avatar.gender === "female"?"avatar female":"avatar female d-none"}>
                                    <div className="hair">
                                        <img src={ process.env.PUBLIC_URL+`img/${female_hair_color_obj[avatar.hair_color]}` } width="73" alt="" title="" />
                                    </div>
                                    <div className="face">
                                        <img src={ process.env.PUBLIC_URL+`img/${skin_color_obj[avatar.skin_tone]}` }  width="54" alt="" title="" />
                                    </div>
                                    <div className="body">
                                        <img src={ process.env.PUBLIC_URL+`img/${dress[avatar.dress_color]}` } width="92" alt="" title="" />
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Ongoing debate div --> */}
                            <div className="debate-ongoing d-nones">
                                <div className="timerWrap">

                                    <div className="timerTitle">
                                        Time Left
                                    </div>
                                    {debate.debate.debate_id
                                    ?
                                    
                                    <TimerFunction type="mediator" total_hour={debate.debate.total_hour} total_minutes={debate.debate.total_minutes} room_id={room_id}/>
                                    :
                                    ""
                                    }
                                    {/* <div id="timer" className="timer" data-hours={debate.debate.total_hour} data-minutes={debate.debate.total_minutes} data-seconds='0'></div> */}
                                    <div className="timeLabels">
                                        <span>hr</span>
                                        <span>min</span>
                                        <span>sec</span>
                                    </div>

                                </div>
                                <div className="next-topic mb-3 d-none">
                                        <span>Topics</span>
                                        <div className="dropdown">
                                            <a className="dropdown-toggle" href="#" role="button" id="nextTopic1"
                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {topic.action
                                                ?
                                                <span id= "selected_topic">{topic.action === "topic" ? topic.data:'Something went Wrong'}</span>                                        
                                                :
                                                <span id= "selected_topic">Select here which topic you want to start</span>
                                                }
                                            </a>
                                            {debate.extra_details.topics ?
                                            <div className="dropdown-menu" aria-labelledby="nextTopic1">
                                                {debate.extra_details.topics.map((element)=>(
                                                    <li className="dropdown-item" onClick={()=>sendMessage({"action":"topic","data":element})} >
                                                        {element} 
                                                    </li>
                                                ))}
                                            
                                            
            
                                            </div>
                                            :
                                            ""
                                            }

                                            {/* <!-- Put the className dropdown-item dropdown-item-done when topic will be done --> */}
                                        </div>
                                        {/* <!-- <p>InterBranis topic name one long topic so long</p> --> */}
                                </div>

                                {/* <!-- when paused change name of pause-icon to play-icon --> */}
                                <span  className="play-pause-debate-btn d-none" >
                                    {start === true ?
                                    <span  id="pause" onClick={()=>startTimer({action:"timer",data:{pause:true,team:"both_team"}})} style={{cursor:"pointer"}}><img src={process.env.PUBLIC_URL +"img/play-icon.png"} alt="" title="" width="10" />
                                    Start Debate</span>
                                    :
                                    <span   id="resume" onClick={()=>startTimer({action:"timer",data:{pause:false,team:"both_team"}})} style={{cursor:"pointer"}}><img src={process.env.PUBLIC_URL + "img/pause-icon.png"  } alt="" title="" width="10" />
                                    Stop Debate</span>
                                    }

                                </span>
                            </div>

                            {/* <!-- Finished debate div --> */}
                            <div className="debate-finished">
                                <div className="dashboard-finished-wrap">
                                    <div className="finished d-none">
                                        Finished!
                                    </div>
                                    <div className="next-topic mb-3">
                                        {/* <span>Mark This Topic Complete</span> */}
                                        {finishDebate === false ?

                                        (secureLocalStorage.getItem("topic") ?
                                        <button class={complete.includes(secureLocalStorage.getItem("topic")) ? "check-button" :"running-button"} onClick={()=>markComplete(secureLocalStorage.getItem("topic"))}>
                                            <span className="check-icon">&#10003;</span>{complete.includes(secureLocalStorage.getItem("topic")) ? "Completed": "Mark This Topic Complete"}
                                        </button>
                                        :
                                        ""
                                        )
                                        :
                                        <button className="running-button" onClick={()=>markDebateFinish()}><span className="check-icon">&#10003;</span>Announce The Winner</button>
                                        }

                                        <div className="dropdown">
                                            <a className="dropdown-toggle" href="#" role="button" id="nextTopic2"
                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                                                {topic.action
                                                ?
                                                <span id= "selected_topic">{topic.action === "topic" ? topic.data:'Something went Wrong'}</span>                                        
                                                :
                                                <span id= "selected_topic">{secureLocalStorage.getItem("topic")? secureLocalStorage.getItem("topic") :"Select here which topic you want to start"}</span>
                                                }

                                            </a>

                                            {debate.extra_details.topics ?
                                            <div className="dropdown-menu" aria-labelledby="nextTopic2">
                                                {debate.extra_details.topics[0].map((element)=>(
                                                    <li className= {complete.includes(element) ? "dropdown-item dropdown-item-done":"dropdown-item"} onClick={()=>sendMessage({"action":"topic","data":element})} >
                                                        {element} 
                                                    </li>
                                                ))}
                                                {/* <li className="dropdown-item dropdown-item-done">
                                                    InterBranis topic name one long topic so long
                                                </li>
                                                <li className="dropdown-item dropdown-item-active">
                                                    InterBranis topic name one long topic so long
                                                </li> */}
                                            
                                            
            
                                            </div>
                                            :
                                            ""
                                            }

                                            {/* <div className="dropdown-menu" aria-labelledby="nextTopic2">
                                                
                                                <li className="dropdown-item dropdown-item-done">
                                                    InterBranis topic name one long topic so long
                                                </li>
                                                <li className="dropdown-item dropdown-item-active">
                                                    InterBranis topic name one long topic so long
                                                </li>
                                                <li className="dropdown-item">
                                                    InterBranis topic name
                                                </li>
                                                <li className="dropdown-item">
                                                    InterBranis topic name one long topic so long
                                                </li>
                                                <li className="dropdown-item">
                                                    InterBranis topic name one long topic so long
                                                </li>

                                            </div> */}
                                        </div>
                                        {/* <!-- <p>InterBranis topic name one long topic so long</p> --> */}
                                    </div>
                                </div>
                                <span  className="play-pause-debate-btn" >
                                    {/* {start ?
                                    <span  id="pause" className={speak?"":"disabled"} ><img src={process.env.PUBLIC_URL +"img/play-icon.png"} alt="" title="" width="10" />
                                    Start Debate</span>
                                    :
                                    <span   id="resume" className={speak?"":"disabled"}><img src={process.env.PUBLIC_URL + "img/pause-icon.png"  } alt="" title="" width="10" />
                                    Stop Debate</span>
                                
                                    } */}
                                    {start === true ?
                                    <span  id="pause" onClick={()=>startTimer({action:"timer",data:{pause:true,team:"both_team"}})} style={{cursor:"pointer"}}><img src={process.env.PUBLIC_URL +"img/play-icon.png"} alt="" title="" width="10" />
                                    Start Debate</span>
                                    :
                                    <span   id="resume" onClick={()=>startTimer({action:"timer",data:{pause:false,team:"both_team"}})} style={{cursor:"pointer"}}><img src={process.env.PUBLIC_URL + "img/pause-icon.png"  } alt="" title="" width="10" />
                                    Stop Debate</span>
                                    }

                                </span>
                            </div>
                        </div>

                        <div className="dashboard-team-block">
                            <div className="dashboard-team-block-title">
                                Team 2
                            </div>

                            <div className="dashboard-team-block-votes">
                                <div className="vote-numbers">
                                    <svg width="15" height="16" viewBox="0 0 15 16" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0.595854 7.06724C0.655338 7.00605 0.733286 6.97393 0.811902 6.97361H3.16775C3.24682 6.97388 3.32521 7.00611 3.38508 7.06752C3.44536 7.12935 3.48152 7.21575 3.48183 7.30849V15.1651C3.48152 15.2579 3.44536 15.3443 3.38508 15.4061C3.32528 15.4674 3.24698 15.4997 3.168 15.5H0.811789C0.733213 15.4997 0.655311 15.4675 0.595854 15.4064C0.535842 15.3446 0.499975 15.2584 0.5 15.1659V15.1658V7.30786L0.5 7.30772C0.499975 7.21523 0.535842 7.12896 0.595854 7.06724ZM12.9848 14.1342C12.9479 14.2258 12.8941 14.3082 12.8271 14.3772L4.92745 14.4749V7.31182C5.11068 7.09108 5.25736 6.84116 5.36163 6.57196L5.36205 6.57088L6.65442 3.21104L6.68775 3.12438V3.03154V1.04549C6.70707 0.888174 6.78247 0.746416 6.89579 0.646649C7.00998 0.546121 7.15446 0.495115 7.30033 0.50037C7.43308 0.506959 7.56363 0.540755 7.68435 0.600205C7.80575 0.659988 7.91507 0.744671 8.00536 0.849869L8.0053 0.849918L8.01106 0.856395C8.32216 1.20643 8.56246 1.61749 8.71718 2.06563C8.87183 2.51361 8.93767 2.98913 8.91061 3.46408C8.89071 3.79856 8.83256 4.12939 8.73743 4.44973C8.66957 4.66854 8.57571 4.87766 8.45812 5.07238L8.44917 5.08719L8.44127 5.10259C8.42606 5.13223 8.40951 5.16192 8.38609 5.20391C8.3828 5.20981 8.37938 5.21595 8.3758 5.22237L7.9617 5.9657H8.8126H13.6472C13.8406 5.96621 14.0297 6.03511 14.1823 6.16344C14.3353 6.29208 14.4424 6.47301 14.4826 6.67694C14.5228 6.88098 14.4928 7.09259 14.3989 7.2753C14.3051 7.45778 14.1542 7.59857 13.9744 7.67673L13.2285 8.00093L13.8545 8.52013C13.861 8.52552 13.8672 8.53147 13.873 8.53796L13.8797 8.54535L13.8866 8.55248C14.0541 8.72469 14.1504 8.96063 14.1505 9.20921C14.1504 9.38917 14.0998 9.56441 14.0062 9.71405C13.9126 9.86362 13.7803 9.98067 13.6265 10.0531L12.9216 10.3849L13.5169 10.8875C13.6483 10.9984 13.748 11.1465 13.8028 11.3156C13.8576 11.4848 13.8647 11.6668 13.8232 11.8402C13.7817 12.0136 13.6937 12.1699 13.5709 12.2916C13.4483 12.4133 13.2961 12.4956 13.1325 12.5308L12.3084 12.7085L12.8595 13.3465C12.9757 13.4811 13.0414 13.657 13.0409 13.8411L13.0409 13.843C13.041 13.9433 13.0218 14.0422 12.9848 14.1342Z"
                                            stroke="#7024c4" fill="#7024c4" />
                                    </svg>
                                    <a id="team2totalvotemediator">{debate.debate.team_2_vote}</a>
                                </div>
                                <span>votes</span>
                            </div>

                            <div className="dashboard-team-block-time">
                                Time Left
                                {debate.debate.debate_id 
                                ?
                                <TeamTimer team="right_team" total_hour={debate.debate.total_hour} total_minutes={debate.debate.total_minutes} room_id={room_id} virtual_id={virtaul_id}/>
                                :
                                ""
                                }
                            </div>
                        
                            <span id="right_side_stop"  href="#" className={rightSpeak ? "btn btn-primary btn-primary-o mb-2":"btn btn-primary btn-primary-o mb-2 d-none"} onClick={()=>teamStartStop({action:"timer",data:{pause:false,team:"right_team"}})}>
                                <svg className="mr-2" width="15" height="22" viewBox="0 0 15 22" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M14.4444 5.71464C14.1389 5.71464 13.8889 5.97179 13.8889 6.28609V10.5719C13.8889 14.2006 11.0278 17.1436 7.5 17.1436C3.97222 17.1436 1.11111 14.2006 1.11111 10.5719V6.28609C1.11111 5.97179 0.861111 5.71464 0.555556 5.71464C0.25 5.71464 0 5.97179 0 6.28609V10.5719C0 14.6292 3.05556 17.9721 6.94444 18.2579V20.8579H3.88889C3.58333 20.8579 3.33333 21.1151 3.33333 21.4294C3.33333 21.7437 3.58333 22.0008 3.88889 22.0008H11.6667C11.9722 22.0008 12.2222 21.7437 12.2222 21.4294C12.2222 21.1151 11.9722 20.8579 11.6667 20.8579H8.05556V18.2579C11.9444 17.9721 15 14.6292 15 10.5719V6.28609C15 5.97179 14.75 5.71464 14.4444 5.71464Z" />
                                    <path
                                        d="M7.5007 15.429C10.1118 15.429 12.2229 13.2575 12.2229 10.5717V4.85729C12.2229 2.17149 10.1118 0 7.5007 0C4.88959 0 2.77848 2.17149 2.77848 4.85729V10.5717C2.77848 13.2575 4.88959 15.429 7.5007 15.429ZM3.88959 9.42885H7.22292C7.52848 9.42885 7.77848 9.1717 7.77848 8.8574C7.77848 8.54311 7.52848 8.28596 7.22292 8.28596H3.88959V7.14307H7.22292C7.52848 7.14307 7.77848 6.88592 7.77848 6.57162C7.77848 6.25733 7.52848 6.00018 7.22292 6.00018H3.88959V4.85729H7.22292C7.52848 4.85729 7.77848 4.60014 7.77848 4.28584C7.77848 3.97155 7.52848 3.7144 7.22292 3.7144H4.05626C4.52848 2.22864 5.88959 1.14289 7.5007 1.14289C9.5007 1.14289 11.1118 2.80008 11.1118 4.85729V10.5717C11.1118 12.6289 9.5007 14.2861 7.5007 14.2861C5.5007 14.2861 3.88959 12.6289 3.88959 10.5717V9.42885Z" />
                                    <line x1="13.3904" y1="1.31235" x2="1.39043" y2="16.3123" stroke="#F1592A" />
                                </svg>
                                Stop
                            </span>

                                
                            <span id="right_side_speak"  href="#" className={rightSpeak == false ?"btn btn-primary mb-2":"btn btn-primary mb-2 d-none"} onClick={()=>teamStartStop({action:"timer",data:{pause:true,team:"right_team"}})}>
                                <svg className="mr-2" width="15" height="22" viewBox="0 0 15 22" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M14.4444 5.71464C14.1389 5.71464 13.8889 5.97179 13.8889 6.28609V10.5719C13.8889 14.2006 11.0278 17.1436 7.5 17.1436C3.97222 17.1436 1.11111 14.2006 1.11111 10.5719V6.28609C1.11111 5.97179 0.861111 5.71464 0.555556 5.71464C0.25 5.71464 0 5.97179 0 6.28609V10.5719C0 14.6292 3.05556 17.9721 6.94444 18.2579V20.8579H3.88889C3.58333 20.8579 3.33333 21.1151 3.33333 21.4294C3.33333 21.7437 3.58333 22.0008 3.88889 22.0008H11.6667C11.9722 22.0008 12.2222 21.7437 12.2222 21.4294C12.2222 21.1151 11.9722 20.8579 11.6667 20.8579H8.05556V18.2579C11.9444 17.9721 15 14.6292 15 10.5719V6.28609C15 5.97179 14.75 5.71464 14.4444 5.71464Z"
                                        fill="white" />
                                    <path
                                        d="M7.5007 15.429C10.1118 15.429 12.2229 13.2575 12.2229 10.5717V4.85729C12.2229 2.17149 10.1118 0 7.5007 0C4.88959 0 2.77848 2.17149 2.77848 4.85729V10.5717C2.77848 13.2575 4.88959 15.429 7.5007 15.429ZM3.88959 9.42885H7.22292C7.52848 9.42885 7.77848 9.1717 7.77848 8.8574C7.77848 8.54311 7.52848 8.28596 7.22292 8.28596H3.88959V7.14307H7.22292C7.52848 7.14307 7.77848 6.88592 7.77848 6.57162C7.77848 6.25733 7.52848 6.00018 7.22292 6.00018H3.88959V4.85729H7.22292C7.52848 4.85729 7.77848 4.60014 7.77848 4.28584C7.77848 3.97155 7.52848 3.7144 7.22292 3.7144H4.05626C4.52848 2.22864 5.88959 1.14289 7.5007 1.14289C9.5007 1.14289 11.1118 2.80008 11.1118 4.85729V10.5717C11.1118 12.6289 9.5007 14.2861 7.5007 14.2861C5.5007 14.2861 3.88959 12.6289 3.88959 10.5717V9.42885Z"
                                        fill="white" />
                                </svg>
                                Speak
                            </span>

                        </div>
                    </div>
                    
                    
                </div>
                
            
                </div>
                

        </>
    );
}

export default Mediator;